<div class="table-wrapper" [ngClass]="variant" [class.table-overflow]="showLoader">
  <div class="table-utils" *ngIf="false">
    <div class="table-count"></div>
    <div class="utils">
      <div class="util-drpdown">
        <select class="form-control nr-select">
          <option class="option-data">Export as....</option>
        </select>
      </div>
      <div class="util-drpdown">
        <select class="form-control nr-select">
          <option>Customize</option>
        </select>
      </div>
    </div>
  </div>

  <div class="table" role="table">
    <div class="row header" role="row">
      <div
      role="columnheader"
      class="cell checkbox-cell"
      *ngIf="showCheckbox"
    >
      <div class="header-wrapper cell-content">
        <mat-checkbox
          #selectAll
          [checked]="isSelectedAll"
          (change)="selectDeselectAll($event)"
          [color]="'primary'"
          class="nr-checkbox nr-checkbox-md"
        >
        </mat-checkbox>
      </div>
    </div>
      <ng-container *ngFor="let header of columnHeader; let i = index">
        <div
          class="cell"
          role="columnheader"
          [attr.aria-sort]="getAriaSort(header)"
          [ngClass]="{ 'xs-col': showCheckbox && !header.isSortable }"
        >
          <div class="header-wrapper cell-content">
            <button
              *ngIf="header.isSortable; else noSortHeader"
              class="header-title"
              (click)="sortHeader($event, header, i)"
            >
              {{ header.title }}
              <div *ngIf="header.isSortable" class="nr-icon-btn ml-1">
                <mat-icon svgIcon="ChevronUp" class="filter-icn ChevronUp" aria-hidden="false" [ngClass]="{
                  'opacityFull': getSortIcon(header) == 'ChevronUp' ,
                  'opacityHalf': getSortIcon(header) !== 'ChevronUp'  }" ></mat-icon>
                <br/>
                <mat-icon svgIcon="ChevronDown" class="filter-icn ChevronDown" [ngClass]="{
                  'opacityFull': getSortIcon(header) == 'ChevronDown' ,
                  'opacityHalf': getSortIcon(header) !== 'ChevronDown'  }" aria-hidden="false" ></mat-icon>
              </div>
            </button>
            <ng-template #noSortHeader>
              <div class="header-title">
                {{ header.title }}
              </div>
            </ng-template>
            <div *ngIf="!myUserGroup"
              class="filter-img"
              #sortTh
              [ngClass]="{ hideContent: header.isSearchable == false }"
            >
              <button
                #filterToggle
                type="button"
                id="filter-btn"
                aria-label="Filter column"
                [attr.aria-pressed]="
                  selectedHeaderIndex == i && showFilterPopUp
                "
                (click)="onFilterClick(header, i, filterToggle)"
                class="nr-icon-btn"
                [ngClass]="getFilterBtnClass(header, i)">
              <mat-icon svgIcon="icon-filter-fill" *ngIf="isFiltered(header); else notFiltered"
                  class="filter-active-icn" aria-hidden="false"></mat-icon>
              </button>
              <ng-template #notFiltered>
                <mat-icon svgIcon="icon-filter" class="filter-inactive-icn" aria-hidden="false" ></mat-icon>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="columnRowData.length > 0">
      <div
        role="row"
        class="row body"
        *ngFor="let data of columnRowData; let i = index "
        [ngClass]="{ prt: isRowClickable == true }"
        
        [tabindex]="isRowClickable ? '0' : '-1'"
      >
        <!-- <div class="cell" *ngIf="isDashboardTable()">
          <div class="nr-err-icon">
            <svg *ngIf="data.isDataQualityIssue" title="warning icon" id="Icon_material-error" data-name="Icon material-error" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path id="Icon_material-error-2" data-name="Icon material-error" d="M11,3a8,8,0,1,0,8,8A8,8,0,0,0,11,3Zm.8,12H10.2V13.4h1.6Zm0-3.2H10.2V7h1.6Z" transform="translate(-3 -3)" fill="#bb0023"/>
            </svg>
          </div>
        </div> -->
        <ng-container *ngIf="columnRowData.length > 0">
          <div
            role="cell"
            class="cell checkbox-cell"
            *ngIf="showCheckbox"
          >
            <mat-checkbox
              [checked]="data.isSelected"
              (change)="setValue($event, i)"
              [color]="'primary'"
              class="nr-checkbox nr-checkbox-md"
            >
            </mat-checkbox>
          </div>
          <div
            role="cell"
            class="cell"
            *ngFor="let col of columnHeader; let i = index"
            (click)="selectedRowDetails(data)"
            (keyup.enter)="selectedRowDetails(data)"
          >
            <div *ngIf="!dynamicContent(col)" class="cell-content text-break">
              <span class="columncol">{{ getData(data, col.id) }}</span>
            </div>
            <div *ngIf="dynamicContent(col)" class="cell-content text-break">
              <ng-container
                *ngTemplateOutlet="
                  dynamicContent(col);
                  context: {
                    column: col,
                    rowData: data,
                    parentDataIndex: i,
                    viewData: getData(data, col.id)
                  }
                "
              >
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

  </div>
  <div *ngIf="columnRowData.length === 0 && noDataMsg && !showLoader" class="no-content">
    <div>{{ noDataMsg }}</div>
  </div>
  <div class="overlay" *ngIf="showLoader">
    <div  class="loader">
      <mat-spinner strokeWidth="2" diameter="50" color="#000"></mat-spinner>
    </div>
  </div>
</div>
<!--     pageLength > pageSizeOptions[0] add-->
<div
  class="table-paginator"
  *ngIf="columnRowData.length != 0 &&  showPaginator">
  <mat-paginator
    #paginator
    style-paginator
    class="nr-paginator"
    [length]="pageLength"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="true"
    [showTotalPages]="5"
    (page)="getPaginatorData($event)"
  ></mat-paginator>
</div>

<!-- The filter popup -->
<div class="filter-container">
  <div class="filter-container-position">
    <app-table-filter-on-column
      *ngIf="showColumnLevelFilter"
      [searchDataResult]="searchDataResult"
      [objPosition]="objPosition"
      [columnId]="columnId"
      (closeFilterOverlay)="closeFilter('')"
      (filterData)="applyColumnFilter($event)"
    ></app-table-filter-on-column>
    <!-- {{ columnRowDataBackup | json }} -->
    <app-table-filter-serverside
      *ngIf="showFilterPopUp && !isColumnLevelFilter"
      [searchDataResult]="searchDataResult"
      [filtersOnDashboard]="filtersOnDashboard"
      [searchLabel]="searchLabel"
      [columnRowData]="columnRowData"
      [objPosition]="objPosition"
      [columnRowDataBackup]="columnRowDataBackup"
      (closeFilterOverlay)="closeFilter($event)"
      (searchKeyword)="tableSearch($event)"
    ></app-table-filter-serverside>
  </div>
</div>
